<template>
     <div class="ck-list-class">
        <div class="add-ck-item" slot="title">
            <span>失效CK列表</span>
            <!-- <el-button type="primary" size="mini" icon = "el-icon-plus" class="add-ck-item-btn" :disabled = "!canAdd" @click="addCKItem">添加CK</el-button> -->
        </div>
        <div class="ck-list">
            <div class="ck-item" v-for="(item, index) in ckList" :key="index">
                <div class="ck-item-con"><span class="ck-label">商户：</span><span class="ck-value">{{item.trader_name}}</span></div>
                <div class="ck-item-con"><span class="ck-label">CK名称：</span><span class="ck-value">{{item.ck_name}}</span></div>
                <div class="ck-item-con"><span class="ck-label">最新时间：</span><span class="ck-value">{{item.update_time}}</span></div>
            </div>
            <div class="pl10 c909399 fs12" v-if="ckList.length == 0">暂无失效CK</div>
        </div>
        <!-- <el-table class="table-class" :data="ckList" style="width: 100%;" border header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
            <el-table-column  prop="trader_name" label="商户"></el-table-column>
            <el-table-column  prop="ck_name" label="CK名称"></el-table-column>
            <el-table-column  prop="update_time" label="更新时间"></el-table-column>         
        </el-table> -->
      
    </div>
</template>
<script>
export default {
    name: 'CKList',
    props:{
        dialogVisible:{
            type: Boolean,
            default: false,
        },
       
        ckList:{
            type: Array,            
            required:true,
            default:[],            
        }  

    },
    data(){        
        
    return {
    }
    },
    mounted() { 
    },

    methods: {
        close() {
            this.$emit('closeCKDialog')
        },

    }

}
</script>

<style lang="scss" scoped>
    .ck-list-class{
        min-width: 200px;
        .add-ck-item{
            border-bottom: 1px solid #ddd;
            padding-bottom: 10px;
            padding-left: 20px;
        }
        .ck-list{
            padding: 10px;
            max-height: 280px;
            overflow: auto;
            .ck-item{
                padding: 10px;
                border-bottom: 1px solid #ddd;
                line-height: 1.5;
                .ck-item-con{
                    font-size: 12px;
                    .ck-label{
                        color: #303133
                    }
                    .ck-value{
                        color: #606266
                    }

                }
            }
           
        }

    }
</style>